import { ComponentType } from 'react';
import { IS_DEMO_MODE } from 'config/demo';
import { CustomIconProps } from 'components/icons';
import AboutIcon from 'components/icons/side-bar/AboutIcon';
import HomeIcon from 'components/icons/side-bar/HomeIcon';
import MapIcon from 'components/icons/side-bar/MapIcon';
import MarketIcon from 'components/icons/side-bar/MarketIcon';

interface ISideBarItem {
  icon: ComponentType<CustomIconProps>;
  text: string;
  path: string;
  type: 'INTERNAL' | 'EXTERNAL';
}

const demoSidebarItems: ISideBarItem[] = [
  {
    path: '/character',
    icon: MarketIcon,
    text: 'Market',
    type: 'INTERNAL',
  },
  {
    path: '/dashboard',
    icon: HomeIcon,
    text: 'Dashboard',
    type: 'INTERNAL',
  },
];

const productionSidebarItems: ISideBarItem[] = [
  {
    path: 'https://cosmicuniverse.one/',
    icon: HomeIcon,
    text: 'Home',
    type: 'EXTERNAL',
  },
  {
    path: '/',
    icon: MarketIcon,
    text: 'Market',
    type: 'INTERNAL',
  },
  {
    path: 'https://cosmicuniverse.one/map',
    icon: MapIcon,
    text: 'Map',
    type: 'EXTERNAL',
  },
  {
    path: 'https://info.cosmicuniverse.one/',
    icon: AboutIcon,
    text: 'About',
    type: 'EXTERNAL',
  },
];

const sidebarItems: ISideBarItem[] = IS_DEMO_MODE ? demoSidebarItems : productionSidebarItems;

export default sidebarItems;
